<app-header fxLayout="column"></app-header>

<div fxLayout="row" fxFlex="100">
    <!-- <app-caro fxLayout="column" fxFlex="300px"></app-caro> -->
 <div class="content" fxLayout="column" fxFlex>
   <router-outlet></router-outlet>
 </div>
</div>

<app-footer fxLayout="column"></app-footer>